<p-card [style]="{'margin-bottom': '1rem'}">
  <ng-template pTemplate="header">
    <div class="property-header">
      <label class="property-title">{{ title }}</label>
      @if (subtitle) {
        <p class="property-subtitle">{{ subtitle }}</p>
      }
    </div>
  </ng-template>

  <div class="property-content">
    @if (isNullable) {
      <div class="null-toggle">
        <p-toggleSwitch
          [(ngModel)]="isNull"
          (ngModelChange)="onNullToggle($event)"
          [disabled]="disabled">
        </p-toggleSwitch>
        <label i18n="@@propertyEditor.setNull">Set as NULL</label>
      </div>
    }

    <div class="property-input" [class.disabled]="isNull || disabled">
      @if (!isNull) {
        @if (isEnum) {
          <!-- Enum dropdown -->
          <p-select
            [(ngModel)]="value"
            (ngModelChange)="onValueChange($event)"
            [options]="enumOptions"
            optionLabel="label"
            optionValue="value"
            i18n-placeholder="@@propertyEditor.selectValue"
            placeholder="Select a value"
            [disabled]="disabled"
            styleClass="w-full">
          </p-select>
        } @else {
          @switch (propertyType) {
            @case ('boolean') {
              <!-- Boolean toggle switch -->
              <p-toggleSwitch
                [(ngModel)]="value"
                (ngModelChange)="onValueChange($event)"
                [disabled]="disabled">
              </p-toggleSwitch>
            }
            @case ('integer') {
              <!-- Integer input -->
              @if (minValue !== undefined && maxValue !== undefined) {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [min]="minValue"
                  [max]="maxValue"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterInteger"
                  placeholder="Enter integer value">
                </p-inputNumber>
              } @else if (minValue !== undefined) {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [min]="minValue"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterInteger"
                  placeholder="Enter integer value">
                </p-inputNumber>
              } @else if (maxValue !== undefined) {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [max]="maxValue"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterInteger"
                  placeholder="Enter integer value">
                </p-inputNumber>
              } @else {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="0"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterInteger"
                  placeholder="Enter integer value">
                </p-inputNumber>
              }
            }
            @case ('number') {
              <!-- Number input with decimals -->
              @if (minValue !== undefined && maxValue !== undefined) {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [min]="minValue"
                  [max]="maxValue"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="10"
                  [step]="0.1"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterNumber"
                  placeholder="Enter numeric value">
                </p-inputNumber>
              } @else if (minValue !== undefined) {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [min]="minValue"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="10"
                  [step]="0.1"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterNumber"
                  placeholder="Enter numeric value">
                </p-inputNumber>
              } @else if (maxValue !== undefined) {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [max]="maxValue"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="10"
                  [step]="0.1"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterNumber"
                  placeholder="Enter numeric value">
                </p-inputNumber>
              } @else {
                <p-inputNumber
                  [(ngModel)]="value"
                  (ngModelChange)="onValueChange($event)"
                  [showButtons]="false"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="10"
                  [step]="0.1"
                  [disabled]="disabled"
                  styleClass="w-full"
                  i18n-placeholder="@@propertyEditor.enterNumber"
                  placeholder="Enter numeric value">
                </p-inputNumber>
              }
            }
            @case ('array') {
              <!-- Array editor -->
              <div class="array-editor">
                @for (item of arrayItems; track $index) {
                  <div class="array-item">
                    @if (isArrayItemEnum) {
                      <p-select
                        [ngModel]="item"
                        (ngModelChange)="updateArrayItem($index, $event)"
                        [options]="arrayItemEnumOptions"
                        [disabled]="disabled"
                        styleClass="array-item-input">
                      </p-select>
                    } @else {
                      @switch (arrayItemType) {
                      @case ('string') {
                        <input
                          pInputText
                          [ngModel]="item"
                          (ngModelChange)="updateArrayItem($index, $event)"
                          [disabled]="disabled"
                          class="array-item-input"
                          i18n-placeholder="@@propertyEditor.enterValue"
                          placeholder="Enter value">
                      }
                      @case ('integer') {
                        <p-inputNumber
                          [ngModel]="item"
                          (ngModelChange)="updateArrayItem($index, $event)"
                          [showButtons]="false"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="0"
                          [disabled]="disabled"
                          styleClass="array-item-input"
                          i18n-placeholder="@@propertyEditor.enterValue"
                          placeholder="Enter value">
                        </p-inputNumber>
                      }
                      @case ('number') {
                        <p-inputNumber
                          [ngModel]="item"
                          (ngModelChange)="updateArrayItem($index, $event)"
                          [showButtons]="false"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="10"
                          [disabled]="disabled"
                          styleClass="array-item-input"
                          i18n-placeholder="@@propertyEditor.enterValue"
                          placeholder="Enter value">
                        </p-inputNumber>
                      }
                      @case ('boolean') {
                        <p-toggleSwitch
                          [ngModel]="item"
                          (ngModelChange)="updateArrayItem($index, $event)"
                          [disabled]="disabled">
                        </p-toggleSwitch>
                      }
                      @default {
                        <input
                          pInputText
                          [ngModel]="item"
                          (ngModelChange)="updateArrayItem($index, $event)"
                          [disabled]="disabled"
                          class="array-item-input"
                          i18n-placeholder="@@propertyEditor.enterValue"
                          placeholder="Enter value">
                      }
                      }
                    }
                    <p-button
                      icon="pi pi-trash"
                      severity="danger"
                      [text]="true"
                      [rounded]="true"
                      size="small"
                      [disabled]="disabled"
                      (click)="removeArrayItem($index)">
                    </p-button>
                  </div>
                }
                <p-button
                  icon="pi pi-plus"
                  i18n-label="@@propertyEditor.addItem"
                  label="Add Item"
                  severity="secondary"
                  [text]="true"
                  size="small"
                  [disabled]="disabled"
                  (click)="addArrayItem()">
                </p-button>
              </div>
            }
            @case ('object') {
              <!-- Nested object — рекурсивно рендерим PropertiesEdit
                   поверх schema.properties. Backend отдаёт вложенные
                   properties как Array<{name, descriptor}>, нормализуем
                   в dict через objectPropertiesDict. -->
              <div class="object-editor">
                <app-properties-edit
                  [schemas]="[objectPropertiesDict]"
                  [values]="value || {}"
                  [disabled]="disabled"
                  (valuesChange)="onValueChange($event)">
                </app-properties-edit>
              </div>
            }
            @default {
              <!-- String input (default) -->
              <input
                pInputText
                [(ngModel)]="value"
                (ngModelChange)="onValueChange($event)"
                [disabled]="disabled"
                class="w-full"
                i18n-placeholder="@@propertyEditor.enterText"
                placeholder="Enter text value">
            }
          }
        }
      }
    </div>

    @if (hasError && !isNull) {
      <div class="error-message">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    }

    @if (!isNull && isNumericType && (minValue != null || maxValue != null)) {
      <div class="constraints">
        @if (minValue != null) {
          <span class="constraint"><ng-container i18n="@@propertyEditor.min">Min:</ng-container> {{ minValue }}</span>
        }
        @if (maxValue != null) {
          <span class="constraint"><ng-container i18n="@@propertyEditor.max">Max:</ng-container> {{ maxValue }}</span>
        }
      </div>
    }
  </div>
</p-card>
